import _ from 'lodash';

import ProjectConstants from './ProjectConstants';
import StoryConstants from '../stories/StoryConstants';

const defaultState = window.state ? window.state.projects : {};

export function projects(state = defaultState, action) {
    switch (action.type) {
        case ProjectConstants.PROJECT_RECEIVED:
            return {
                ...state,
                [action.payload.id]: {
                    id: action.payload.id.toString(),
                    name: action.payload.name,
                    description: action.payload.description,
                    colour: action.payload.colour,
                    account_id: action.payload.account_id.toString(),
                    stories: action.payload.stories.map(story => story.id)
                }
            };
        case ProjectConstants.PROJECT_REMOVED:
            return _.pickBy(state, project => project.id !== action.payload.id);
            break;
        case ProjectConstants.PROJECT_UPDATED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    name: action.payload.name,
                    description: action.payload.description,
                    colour: action.payload.colour,
                }
            };
            break;
        case ProjectConstants.PROJECT_RENAMED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    name: action.payload.name
                }
            };
            break;
        case ProjectConstants.PROJECT_COLOUR_CHANGED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    colour: action.payload.colour
                }
            };
            break;
        case StoryConstants.STORY_REMOVED:
            return _.mapValues(state, project => ({
                ...project,
                stories: Object.values(
                    _.pickBy(project.stories, storyId => storyId !== action.payload.id)
                )
            }));
            break;
        case StoryConstants.STORY_PROJECTS_UPDATED:
            return _.mapValues(state, project => {

                const projectContainsStory = project.stories.includes(action.payload.id);
                const storyContainsProject = action.payload.projects.includes(project.id);

                // Same... ignore
                if (projectContainsStory && storyContainsProject) {
                    return project;
                }

                // Same... ignore
                if (! projectContainsStory && ! storyContainsProject) {
                    return project;
                }

                // Newly added
                if (! projectContainsStory && storyContainsProject) {
                    return {
                        ...project,
                        stories: [...project.stories, action.payload.id]
                    }
                }

                // Newly removed
                if (projectContainsStory && ! storyContainsProject) {
                    return {
                        ...project,
                        stories: project.stories.filter(storyId => storyId !== action.payload.id)
                    }
                }

                return project;
            });
            break;
        default:
            return state;
    }
}
